import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getAsNumber = (
  input: string | undefined | null,
  defaultValue: number | undefined = undefined
) => {
  return input ? Number(input) : defaultValue;
};

const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isUuid = (value: string): boolean => uuidRegex.test(value);

/**
 * Extract a UUID from a slug like "my-title_<uuid>".
 * Strips any trailing query string that may have been URL-encoded into the path segment
 * (e.g. crawlers encoding `?page=3` as `%3Fpage%3D3`).
 */
export const parseIdFromSlug = (slug: string): string | undefined => {
  const raw = slug.split("_").at(-1);
  if (!raw) return undefined;
  const cleaned = raw.split("?")[0];
  return isUuid(cleaned) ? cleaned : undefined;
};

export const getAsInt = (
  input: string | undefined | null,
  defaultValue: number | undefined = undefined
) => {
  return input ? parseInt(input, 10) : defaultValue;
};
